import React from "react";
import "./index.less";
import give from "../../../layout/image/give.png";
import head from "../../../layout/image/head.png";
import safe from "../../../layout/image/safe.png";
import multiple from "../../../layout/image/multiple.png";
import shop from "../../../layout/image/shop.png";
import grid from "../../../layout/image/grid.png";

export default class MainMenuCover extends React.Component {
  constructor(prop) {
    super(prop);
    this.state = {
      bigTitle: [
        {
          id: "give",
          titleName: "商品管理",
          imgUrl: give,
          boxClassName: "big-title-box give-box",
          imgClassName: "big-img give-img",
          titleClassName: "big-title give-title",
        },
        {
          id: "head",
          titleName: "人员管理",
          imgUrl: head,
          boxClassName: "big-title-box head-box",
          imgClassName: "big-img head-img",
          titleClassName: "big-title head-title",
        },
        {
          id: "safe",
          titleName: "拜访管理",
          imgUrl: safe,
          boxClassName: "big-title-box safe-box",
          imgClassName: "big-img safe-img",
          titleClassName: "big-title safe-title",
        },
        {
          id: "multiple",
          titleName: "风控",
          imgUrl: multiple,
          boxClassName: "big-title-box multipe-box",
          imgClassName: "big-img multipe-img",
          titleClassName: "big-title multipe-title",
        },
        {
          id: "shop",
          titleName: "店铺管理",
          imgUrl: shop,
          boxClassName: "big-title-box shop-box",
          imgClassName: "big-img shop-img",
          titleClassName: "big-title shop-title",
        },
        {
          id: "grid",
          titleName: "销售推荐",
          imgUrl: grid,
          boxClassName: "big-title-box grid-box",
          imgClassName: "big-img grid-img",
          titleClassName: "big-title grid-title",
        },
      ],
      smallTitle: [
        {
          id: "cityLight",
          titleName: "信息采集",
          className: "no-img-box city-light",
        },
        {
          id: "effectCheck",
          titleName: "激励考核",
          className: "no-img-box effect-check",
        },
        {
          id: "talkTools",
          titleName: "销售工具",
          className: "no-img-box talk-tools",
        },
        {
          id: "talkComputer",
          titleName: "激励任务",
          className: "no-img-box talk-computer",
        },
        { id: "buyPlan", titleName: "佣金", className: "no-img-box buy-plan" },
      ],
    };
  }
  componentDidMount() {
    //     alert(111)
  }

  render() {
    return (
      <div className="main-menu-box">
        <div className="main-title">一站式客户关系管理端，玩转地勤业务</div>

        <div className="img-box">
          {this.state.bigTitle.map((item) => {
            return (
              <div key={item.id} className={item.boxClassName}>
                <img className={item.imgClassName} src={item.imgUrl} alt="" />
                <span className={item.titleClassName}>{item.titleName}</span>
              </div>
            );
          })}

          {this.state.smallTitle.map((item) => {
            return (
              <div key={item.id} className={item.className}>
                <div className="no-img-title">{item.titleName}</div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}
